export const APP_URL_PREFIX = '/personal/insure/travel-sure-plus-insurance';

export const PAGE_INDICES = {
    LANDING_PAGE: -1,
    QUOTE: 0,
    TRAVEL_DETAILS: 1,
    NEXT_OF_KIN: 2,
    PAYMENT: 3,
};

export const PAGES = [
    {
        URL: `${APP_URL_PREFIX}/get-quote`,
        URL_PART: 'get-quote',
        TITLE: 'Get Quote',
    },
    {
        URL: `${APP_URL_PREFIX}/travel-details`,
        URL_PART: 'travel-details',
        TITLE: 'Travel Details',
    },
    {
        URL: `${APP_URL_PREFIX}/next-of-kin`,
        URL_PART: 'next-of-kin',
        TITLE: 'Next Of Kin',
    },

    {
        URL: `${APP_URL_PREFIX}/payment`,
        URL_PART: 'payment',
        TITLE: 'Payment',
    },
];

export const COVER_PLANS = {
    WORLDWIDE_COVER: {
        title: 'Worldwide',
        value: 'Worldwide Essential',
        imageUrl: 'https://www.oldmutual.co.ug/om-docs/blt87e7a5716d0ff095/Worldwide.svg',
    },
    SCHENGEN_COVER: {
        title: 'Schengen',
        value: 'Schengen Essential',
        imageUrl: 'https://www.oldmutual.co.ug/om-docs/bltf37cf75bdf1f9674/Schengen.svg',
    },
    STUDENT_COVER: {
        title: 'Student Cover',
        value: 'Student Cover',
        imageUrl: 'https://www.oldmutual.co.ug/om-docs/blt9f2bd4a3e70364c0/Student.svg',
    },
    AFRICA_ASIA_COVER: {
        title: 'Africa & Asia',
        value: 'Africa & Asia',
        imageUrl: 'https://www.oldmutual.co.ug/om-docs/bltae163e5ec0b12394/AfricaAsia.svg',
    },
    INBOUND_COVER: {
        title: 'Inbound Karibu',
        value: 'Inbound Karibu',
        imageUrl: 'https://www.oldmutual.co.ug/om-docs/bltd292ec30995b8813/Inbound.svg',
    },
};

export const TOGGLE_STATUS = {
    YES: true,
    NO: false,
    UNTOUCHED: 'untouched',
};

export const TRAVEL_INSURANCE_URLS = {
    QUOTE: PAGES[PAGE_INDICES.QUOTE].URL,
    TRAVEL_DETAILS: PAGES[PAGE_INDICES.TRAVEL_DETAILS].URL,
    NEXT_OF_KIN: PAGES[PAGE_INDICES.NEXT_OF_KIN].URL,
    PAYMENT: PAGES[PAGE_INDICES.PAYMENT].URL,
};
